import { createMiddleware } from '@tanstack/react-start';

import { type DevToolOverrides, parseDevToolOverridesFromRequest } from '@/devTools/overrides';

type TestMiddlewareNext = (devToolOverrides: DevToolOverrides) => Promise<Response>;

function appendClearCookies(response: unknown, cookiesToClear: string[]) {
  if (!(response instanceof Response)) return;

  for (const cookie of cookiesToClear) {
    response.headers.append('Set-Cookie', cookie);
  }
}

export async function runDevToolOverridesMiddlewareTestHarness(request: Request, next: TestMiddlewareNext) {
  const { overrides: devToolOverrides, cookiesToClear } = parseDevToolOverridesFromRequest(request);
  const response = await next(devToolOverrides);

  appendClearCookies(response, cookiesToClear);

  return response;
}

export const devToolOverridesMiddleware = createMiddleware().server(async ({ request, next }) => {
  const { overrides: devToolOverrides, cookiesToClear } = parseDevToolOverridesFromRequest(request);
  const response = await next({ context: { devToolOverrides } });

  appendClearCookies(response, cookiesToClear);

  return response;
});
